<template>
    <BarometerHome />
</template>
<script setup lang="ts">
    import BarometerHome from '~/components/barometer/home/BarometerHome.vue';
</script>
